module.exports = __webpack_public_path__ + "img/survey_01.deefbda7.jpeg";